import { createSlice } from "@reduxjs/toolkit";
import {
  saveProfileEdition,
  sendFeedback,
  getCustomAgentBranch,
} from "./services";

const initialState = {
  loading: true,
  TOKKO_HOST: "",
  hash: null,
  isEdition: false,
  is_from_network: false,
  isImagesEdition: false,
  thereIsChanges: false,
  contact_name: "",
  user_language: "en-US",
  for_colleague: true,
  from_opennavent: false,
  portal_icon: "",
  company_logo: "",
  agents: [],
  branch: {},
  is_contact: false,
  origin_data: {
    pictures: {
      images: [],
      blueprints: [],
      front_cover_image: {},
    },
    videos: [],
    id: 21173,
    attributes_list: [],
    address: "",
    additional: [],
    basic_info: [],
    description: "",
    geolocation: {
      lat: "",
      lng: "",
    },
    location: "",
    operations: {},
    reference: "",
    rooms: [],
    services: [],
    status: {
      id: 1,
      name: "",
    },
    temporary: null,
    type: {},
    measurement: [],
    agent_user: {},
    company: {},
    development: null,
  },
  edited_data: {
    title: "",
    description: "",
    development: { description: "" },
    show_operation_sale: true,
    show_operation_rent: true,
    show_operation_temporary_rent: true,
    custom_branch: {},
    show_contact: false,
    show_logo: false,
    show_agent: false,
    show_branch: false,
    show_location: true,
    has_edition: null,
    pictures: {
      images: [],
      blueprints: [],
      front_cover_image: null,
    },
    videos: {
      360: [],
      normal: [],
    },
    agent_user: {},
  },
  initialEditionData: {},
  feedback: {
    feedbackSended: false,
    likeProperty: null,
  },
  showData: "edited_data",
  show_contact_pdf: false,
  showModalEditionUnsaved: false,
  disabledOperationOff: false,
  colaToast: [],
};

export const FichaInfoSlice = createSlice({
  name: "fichaInfo",
  initialState,
  reducers: {
    setFichaInfoData(state, actions) {
      if (!actions.payload) return;

      const {
        property,
        edited_ficha,
        for_colleague,
        agents,
        public_view,
        hash,
        contact_name,
        contact_email,
        contact_phone,
        contact_id,
        language,
        TOKKO_HOST_PUBLIC,
        user,
        branch,
        show_contact,
        company_logo,
        from_opennavent,
        portal_icon,
        isEdited,
        is_from_network,
      } = actions.payload;

      const agent_user = { ...user, photo: user.picture || "" };
      const { pictures, videos, address, description, development } = property;

      state.origin_data = { ...property, agent_user: agent_user };

      if (!from_opennavent) {
        state.edited_data = {
          ...state.edited_data,
          ...edited_ficha,
          agent_user: {
            ...edited_ficha.custom_agent,
            photo: edited_ficha.custom_agent?.image || "",
            email: edited_ficha.custom_agent?.mail || "",
          },
        };
      }

      state.isBookingActive = property.is_booking_active || false;
      state.bookingUrl = property.booking_url || "";

      if (contact_id) {
        state.bookingUrl = `${state.bookingUrl}?contact_id=${contact_id}`;
      }

      state.contact_id = contact_id;
      state.is_from_network = is_from_network;
      state.user_language = language;
      state.TOKKO_HOST = TOKKO_HOST_PUBLIC;
      state.for_colleague = for_colleague;
      state.from_opennavent = from_opennavent;
      state.portal_icon = portal_icon || "";
      state.agents = agents;
      state.branch = branch;
      state.is_contact = public_view;
      state.contact_name = contact_name;
      state.contact_email = contact_email;
      state.contact_phone = contact_phone;
      state.show_contact_pdf = show_contact;
      state.company_logo = company_logo || "";

      if (!public_view) {
        state.showData = isEdited === "True" ? "edited_data" : "origin_data";
      }

      if (from_opennavent) {
        state.showData = "origin_data";
      }

      if (edited_ficha?.custom_agent) {
        state.edited_data.agent_user = {
          ...edited_ficha.custom_agent,
          photo: edited_ficha.custom_agent.image || "",
          email: edited_ficha.custom_agent.mail || "",
        };
      }
      if (!from_opennavent && !edited_ficha.has_edition && !for_colleague) {
        const initialData = {
          pictures,
          videos,
          title: address,
          description,
          agent_user,
          development,
        };
        state.edited_data = {
          ...state.edited_data,
          ...initialData,
        };
        state.initialEditionData = initialData;
      }
      state.hash = hash;
      state.loading = false;
    },
    setIsEdition(state, actions) {
      state.isEdition = actions.payload;
    },
    setShowModalEditionUnsaved(state, actions) {
      state.showModalEditionUnsaved = actions.payload;
    },
    setShowData(state, actions) {
      state.showData = actions.payload;
    },
    setInitialEditionData(state, actions) {
      const { key, value } = actions.payload;
      if (!key) {
        state.initialEditionData = actions.payload;
      } else {
        state.initialEditionData[key] = value;
      }
    },
    setThereIsChanges(state, actions) {
      state.thereIsChanges = actions.payload;
    },
    setIsImagesEdition(state, actions) {
      state.isImagesEdition = actions.payload;
    },
    setEditedDataBatch(state, actions) {
      state.edited_data = { ...state.edited_data, ...actions.payload };
    },
    setEditedData(state, actions) {
      const { key, value } = actions.payload;
      if (key === "development") {
        state.edited_data[key] = {
          ...state.edited_data[key],
          description: value,
        };
      } else state.edited_data[key] = value;
    },
    setToogleEditionValue(state, actions) {
      const key = actions.payload;
      state.edited_data[key] = !state.edited_data[key];
      if (
        [
          "show_operation_rent",
          "show_operation_sale",
          "show_operation_temporary_rent",
        ].includes(key)
      ) {
        FichaInfoSlice.caseReducers.updateDisabledOperationOff(state);
      }
    },
    setResetFichaInfoState(state, actions) {
      const { key } = actions.payload;
      state[key] = initialState[key];
    },
    setFeedbackInfo(state, actions) {
      const { key, value } = actions.payload;
      state.feedback[key] = value;
    },
    updateDisabledOperationOff(state) {
      const {
        show_operation_rent,
        show_operation_sale,
        show_operation_temporary_rent,
      } = state.edited_data;
      const activeOperations = [
        show_operation_rent && state.origin_data.operations.Rent,
        show_operation_sale && state.origin_data.operations.Sale,
        show_operation_temporary_rent && state.origin_data.operations.Temporary,
      ].filter(Boolean).length;
      state.disabledOperationOff = activeOperations === 1;
    },
    showToast(state, action) {
      state.colaToast = [
        ...state.colaToast,
        { id: state.colaToast.length, ...action.payload },
      ];
    },
    closeToast(state, action) {
      const nuevaCola = state.colaToast.filter(
        (cola) => cola.id !== action.payload
      );

      state.colaToast = nuevaCola;
    },
  },
  extraReducers: (builder) => {
    builder // Save new profile edition
      .addCase(saveProfileEdition.pending, (state) => {
        state.edited_data.loading = true;
      })
      .addCase(saveProfileEdition.fulfilled, (state, action) => {
        state.edited_data.loading = false;
      })
      .addCase(saveProfileEdition.rejected, (state, action) => {
        state.edited_data.loading = false;
      });
    builder // Send feedback
      .addCase(sendFeedback.pending, (state) => {
        state.edited_data.loading = true;
      })
      .addCase(sendFeedback.fulfilled, (state, action) => {
        state.feedback.feedbackSended = true;
        state.feedback.likeProperty =
          action.meta.arg.data.feedback === "like" ? true : false;
      });
    builder // Get custom agent branch
      .addCase(getCustomAgentBranch.pending, (state) => {
        state.edited_data.loading = true;
      })
      .addCase(getCustomAgentBranch.fulfilled, (state, action) => {
        state.edited_data.loading = false;
        const branch = action.payload[0]?.branch || null;
        if (!branch) return;
        state.edited_data = { ...state.edited_data, custom_branch: branch };
      })
      .addCase(getCustomAgentBranch.rejected, (state, action) => {
        state.edited_data.loading = false;
      });
  },
});

export const {
  setIsEdition,
  setShowModalEditionUnsaved,
  setShowData,
  setInitialEditionData,
  setFichaInfoData,
  setEditedOperations,
  setThereIsChanges,
  setIsImagesEdition,
  setEditedData,
  setResetEditedData,
  setFeedbackInfo,
  setResetFichaInfoState,
  setEditedDataBatch,
  showToast,
  closeToast,
  setToogleEditionValue,
  updateDisabledOperationOff,
} = FichaInfoSlice.actions;

export default FichaInfoSlice.reducer;
